import { z } from 'zod';

import type { TranslateFn } from '@/shared/types';

export function emailField(t: TranslateFn): z.ZodString {
    return z.string().email(t('validation.email'));
}
